import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationSort, NotificationWatch } from '../../data-access/notifications.types';

@Component({
    selector: 'app-notification-watch-list',
    templateUrl: './notification-watch-list.component.html',
    styleUrls: ['./notification-watch-list.component.scss']
})
export class NotificationWatchListComponent {
    @Input() watches: NotificationWatch[] = [];
    @Input() isEditing = false;
    @Input() isDeleting = false;
    @Input() sort?: NotificationSort;

    @Output() openWatch = new EventEmitter<NotificationWatch>();
    @Output() toggleEnabled = new EventEmitter<{ watch: NotificationWatch; enabled: boolean }>();
    @Output() watchChanged = new EventEmitter<NotificationWatch>();
    @Output() toggleDeleteSelection = new EventEmitter<NotificationWatch>();
    @Output() sortChanged = new EventEmitter<NotificationSort>();

    selectWatch(watch: NotificationWatch): void {
        this.openWatch.emit(watch);
    }

    onToggleEnabled(watch: NotificationWatch, enabled: boolean): void {
        this.toggleEnabled.emit({ watch, enabled });
    }

    onWatchChanged(watch: NotificationWatch): void {
        this.watchChanged.emit(watch);
    }

    onToggleDeleteSelection(watch: NotificationWatch): void {
        this.toggleDeleteSelection.emit(watch);
    }

    requestSort(sortField: string): void {
        const isSameField = this.sort?.sortField === sortField;
        const sortDesc = isSameField ? !this.sort?.sortDesc : false;
        this.sortChanged.emit({ sortField, sortDesc: !!sortDesc });
    }

    sortIcon(sortField: string): string {
        return this.sort?.sortField === sortField
            ? this.sort.sortDesc
                ? 'arrow_circle_up'
                : 'arrow_circle_down'
            : '';
    }

    isSorted(sortField: string): boolean {
        return this.sort?.sortField === sortField;
    }

    getWatchTypeLabel(watch: NotificationWatch): string {
        if (watch.watchType === 1) {
            return `${(watch.projectIDs || []).length} Selected Projects`;
        }

        if (watch.watchType === 2) {
            return 'Dynamic';
        }

        return '';
    }
}
